import { useEffect, ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface RefIdHandlerProps {
  children: ReactNode;
}

export const RefIdHandler = ({ children }: RefIdHandlerProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Parse URL parameters
    const urlParams = new URLSearchParams(location.search);
    const refId = urlParams.get('refId');

    // If there's a refId and we're on the root path, redirect to chat
    if (refId && location.pathname === '/') {
      // Navigate to chat with the refId as the userId
      navigate(`/chat/${refId}`, { replace: true });
    }
  }, [location.search, location.pathname, navigate]);

  return <>{children}</>;
};
